import { render } from "./KubernetesPage.vue?vue&type=template&id=1a59122e&scoped=true"
import script from "./KubernetesPage.vue?vue&type=script&lang=js"
export * from "./KubernetesPage.vue?vue&type=script&lang=js"

import "./KubernetesPage.vue?vue&type=style&index=0&id=1a59122e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a59122e"]])

export default __exports__